import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, createVNode as _createVNode, unref as _unref, resolveComponent as _resolveComponent, withKeys as _withKeys, withCtx as _withCtx, withModifiers as _withModifiers, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-14a328de"), n = n(), _popScopeId(), n);
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "subtitle" }, "验证身份", -1));
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "explain" }, "为确保账号是您本人操作，请选择一种方式验证身份", -1));
const _hoisted_3 = /*#__PURE__*/ _createTextVNode("立即验证");
import { useRouter, useRoute } from "vue-router";
import CloudTips from "@/components/CloudTips/index.vue";
import { useMFA } from "@/hooks/useMFA";
import { useLogin } from "./hooks";
import { getQueryParam } from "@/utils";
export default /*#__PURE__*/ _defineComponent({
    name: 'MFA',
    setup(__props) {
        const { changeState } = useLogin();
        const router = useRouter();
        const route = useRoute();
        const tipsText = "请在 小程序 或 Google 身份验证器 手机应用获取动态MFA码";
        const redirect_url = getQueryParam("redirect_url");
        const { MFAForm, MFAData, MFARules, submit } = useMFA({
            needBind: false,
            is_login: true
        });
        const getQuery = (value) => {
            let arr = value?.split("&") || [];
            let obj = {};
            for (let item of arr) {
                let piece = item.split("=");
                obj[piece[0]] = piece[1];
            }
            return obj;
        };
        const { redirect } = route.query;
        let pathArr = Array.isArray(redirect)
            ? redirect[0]
            : (redirect || "").split("?");
        const path = (pathArr && pathArr[0]) || "/";
        const query = pathArr ? getQuery(pathArr[1]) : {};
        const submitHandle = () => {
            submit().then(() => {
                changeState("already");
                if (!redirect_url) {
                    router.push({ path: path, query: query });
                }
                else {
                    window.location.href = redirect_url;
                }
            });
        };
        return (_ctx, _cache) => {
            const _component_el_input = _resolveComponent("el-input");
            const _component_el_form_item = _resolveComponent("el-form-item");
            const _component_el_form = _resolveComponent("el-form");
            const _component_el_button = _resolveComponent("el-button");
            return (_openBlock(), _createElementBlock("div", null, [
                _hoisted_1,
                _hoisted_2,
                _createVNode(CloudTips, {
                    class: "neck-box",
                    text: tipsText
                }),
                _createVNode(_component_el_form, {
                    ref_key: "MFAForm",
                    ref: MFAForm,
                    size: "large",
                    model: _unref(MFAData),
                    rules: _unref(MFARules),
                    onSubmit: _cache[1] || (_cache[1] = _withModifiers(() => { }, ["prevent"]))
                }, {
                    default: _withCtx(() => [
                        _createVNode(_component_el_form_item, { prop: "num" }, {
                            default: _withCtx(() => [
                                _createVNode(_component_el_input, {
                                    modelValue: _unref(MFAData).num,
                                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((_unref(MFAData).num) = $event)),
                                    placeholder: "请输入动态MFA码",
                                    onKeydown: _withKeys(submitHandle, ["enter"])
                                }, null, 8, ["modelValue", "onKeydown"])
                            ]),
                            _: 1
                        })
                    ]),
                    _: 1
                }, 8, ["model", "rules"]),
                _createVNode(_component_el_button, {
                    size: "large",
                    type: "primary",
                    class: "login-btn",
                    onClick: submitHandle
                }, {
                    default: _withCtx(() => [
                        _hoisted_3
                    ]),
                    _: 1
                })
            ]));
        };
    }
});
